import { EntityWithCreatedAt } from "./entity";

export class Plan extends EntityWithCreatedAt {
  monthlyStripeSubscriptionId?: string;
  monthlyPrice: number;
  name: string;
  tier: number;
}
